module.exports = __webpack_public_path__ + "media/images/emblems/Rueti-blazon-373b29c67da0b346fdcd352d3dffefe5.svg";